<div class="modal-backdrop" (click)="onBackdrop()" *ngIf="open" role="dialog" aria-modal="true">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <button
      #firstFocusable
      class="modal-close"
      type="button"
      aria-label="Close"
      (click)="onCancel()"
    >
      <mat-icon svgIcon="close" class="header-cross-icon"></mat-icon>
    </button>

    <h2 class="modal-title">{{ title }}</h2>
    <p class="modal-description" *ngIf="message as m">
      {{ m }}
    </p>

    <p class="modal-description">This is a subset of your studies</p>
    <div class="modal-table-heading">
      <span>My studies</span>
    </div>
    <div class="modal-table-container" *ngIf="showTable && tableData">
      <portfolio-table
        [dataSource]="tableData"
        [hasData]="hasData"
        [enableSticky]="true"
        [enableHeaderMenu]="false"
        [enableSort]="false"
      >
      </portfolio-table>
    </div>

    <div class="modal-actions">
      <button class="btn btn-cancel" type="button" (click)="onCancel()">{{ cancelLabel }}</button>
      <button class="btn btn-accept" type="button" (click)="onConfirm()">{{ confirmLabel }}</button>
    </div>
  </div>
</div>
